
import * as deepmerge from 'deepmerge';

export default class Menu {
	/**
	 * @param {string} element - Selector
	 * @param {Object} options - User options
	 */
	constructor(element, options) {
		this.element = element || '.navigation__item--secondary.has-children.is-top-level';
		this.defaults = {
			triggers: this.element,
		};
		this.options = options ? deepmerge(this.defaults, options) : this.defaults;

		window.addEventListener('DOMContentLoaded', () => {
			this.init();
			this.initEvents(this.options.triggers);
		});

	}

	/**
	 * Init
	 */
	init() {
		this.DOM = {
			element: document.querySelectorAll(this.element),
		};
		//this.DOM.child = document.querySelectorAll('.js-test-child');
	}

	/**
	 * Initialize events
	 * @param {string} triggers - Selectors
	 */
	initEvents(triggers) {
		[...document.querySelectorAll(triggers)].forEach((element) => {

			element.firstElementChild.addEventListener("click", (e) => {
				if (window.matchMedia("(max-width: 768px)").matches) {
					e.preventDefault();
					element.classList.toggle("is-active");
					element.lastElementChild.classList.toggle("is-active");
				} else {
					e.preventDefault();
				}
			})
		})
	}


}
